import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { browserName, deviceType, osName } from 'react-device-detect';

import localforage from 'localforage';
import useStores from '../hooks/useStores';
import useUserIdentity from '../hooks/useUserIdentity';

import { DeviceProps } from 'stores/device_store';
// type DeviceType = {
//     key: string;
//     type: string;
// };

type DeviceContextType = {
    updateSub: (sub: PushSubscription) => void;
    // recents: DeviceType[];
    // addRecent?: (recent: DeviceType) => void;
}

export const DeviceContext = React.createContext<DeviceContextType>({
    updateSub: () => { throw "not implemented" }
});


export const DeviceProvider = observer(({ children }: { children: React.ReactNode }) => {
    const [deviceKey, setDeviceKey] = useState(null as string | null);
    const [sub, setSub] = useState(null as PushSubscription | null);
    const { currentIdentity } = useUserIdentity();
    const { deviceStore } = useStores();

    const friendlyName = `${browserName} on ${osName} (${deviceType})`;

    useEffect(() => {
        if(!currentIdentity?.uuid) {
            console.log("no identity uuid, not loading device");
            return;
        }

        const forageKey = `device-key-${currentIdentity.uuid}`;
        localforage.getItem<string>(forageKey).then((k: string | null) => {
            if (k) {
                setDeviceKey(k);
            }
            else {
                deviceStore.create(currentIdentity?.uuid,
                    friendlyName).then((device: DeviceProps) => {
                    const newKey = device.key;
                    localforage.setItem(forageKey, newKey).then(() => {
                        setDeviceKey(newKey);
                    });
                });
            }
        });
    }, [setDeviceKey, currentIdentity?.uuid]);

    useEffect(() => {
        // console.log("Device key changed: %o", deviceKey);
        if (sub && currentIdentity?.uuid && deviceKey) {
            //            console.log("updating the sub via the api!!!");
            deviceStore
                .updateSub(currentIdentity?.uuid,
                    deviceKey,
                    sub.toJSON())
            .catch((e) => {
                console.error("error updating sub: %o", e);
            });
        }
    }, [sub, currentIdentity?.uuid, deviceKey]);


    function updateSub(sub: PushSubscription) {
        setSub(sub);
    }

    const data = {
        updateSub: updateSub
    };

    return (
        <DeviceContext.Provider value={data}>{ children }</DeviceContext.Provider>
    );

});
